import { environment } from '../../environments/environment';
import { ReportsComponent } from './reports.component';
import { roleGuard } from '../shared/core/role-guard.service';

export const routes = [
    { path: 'reports',component:ReportsComponent,
    canActivate: [roleGuard], 
    data: { roles: [environment.clearanceRole, environment.productionRole]}}
];
